import { createActionGroup, props } from '@ngrx/store';
import { Language } from '@lyceo/homi/settings/util-models';

export const SettingsActions = createActionGroup({
  source: 'Settings API',
  events: {},
});

export const SettingsPageActions = createActionGroup({
  source: 'Settings Page',
  events: {
    'Language Changed': props<{ language: Language }>(),
  },
});
